import { NgModule } from "@angular/core";
import { AdvisorStateService } from "./state/advisor.state.service";
import { AdvisorDataService } from "./services/advisor.data.service";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [AdvisorStateService, AdvisorDataService],
})
export class AdvisorModule {}
